import { FileEdit } from '@powerportalspro/react-fluent';

export function FileEditMainSample() {
  return <FileEdit columnName="ppp_contract" />;
}
